import React from "react";
import { Done, DoneAll } from "@material-ui/icons";
import ReplyIcon from "@material-ui/icons/Reply";
import DeleteIcon from "@material-ui/icons/Delete";
import CustomAudioPlayer from "./NewVoiceRecorder/customPlayer";

const VoiceMessage = ({
  chat,
  UserId,
  reply,
  deleteMessage,
  doc,
  prescriptionVoiceStyle,
  prescriptionVoiceStyle2,
}) => {
  const owner = parseInt(UserId) === parseInt(chat.user_id);
  const isFirefox = typeof InstallTrigger !== "undefined";

  return (
    <div key={chat.key} className={owner ? "chat_item me" : "chat_item"}>
      <div className="main_item_chat" style={prescriptionVoiceStyle}>
        <div className="text_chat" style={prescriptionVoiceStyle2}>
          <p>
            <div className="load_audio" >

              {/* <AudioPlayer
                preload="none"
                src={chat.file} 
                showSkipControls={false}
                showJumpControls={false}
                customVolumeControls={[]}
                customAdditionalControls={[]}
                style={prescriptionVoiceStyle2}
                // other props here
              /> */}
              <CustomAudioPlayer audio={chat.file} owner={owner}/>
            </div>

          </p>
          {doc}
        </div>
        <div className="clearfix" />
        <time>{chat.created_at}</time>
        {owner ? (
          <span className="seen">{chat.seen ? <DoneAll /> : <Done />}</span>
        ) : null}

        <div className="clearfix" />
      </div>
      {owner ? (
        <div className="control_message" style={{ display: "inline-block" }}>
          <ReplyIcon
            className="reply_message"
            style={owner ? { fontSize: 20 } : { fontSize: 20, float: "left" }}
            onClick={() => reply(chat)}
          />
          <DeleteIcon
            className="delete_message"
            onClick={() => deleteMessage(chat)}
          />
        </div>
      ) : (
        <div className="control_message" style={{ display: "inline-block" }}>
          <ReplyIcon
            className="reply_message"
            style={owner ? { fontSize: 20 } : { fontSize: 20, float: "left" }}
            onClick={() => reply(chat)}
          />
        </div>
      )}
      <div className="clearfix" />
    </div>
  );
};

export default VoiceMessage;
